<template>
  <div class="container">
    <div v-if="loading" class="text-center">
      <div class="spinner-grow text-primary m-5" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <div v-else>
      <div class="product-types-tabs btn-group" role="group" aria-label="Basic example">
        <button
          type="button"
          class="btn"
          :class="[defaultCategory.categoryId == category.categoryId ? 'active' : '' ]"
          v-for="category in categories"
          :key="category.id"
          @click="getCatogryProducts(category)"
        >{{category.filterTitle}}</button>
      </div>
      <div>
        <p v-if="loading" class="products--loader" :class="{ loading :loading}">loading..</p>
        <div v-else class="products">
          <div
            class="product"
            :class="{'selected-product' : currentProduct && product.productId === currentProduct.productId}"
            v-for="product in (!currentProduct?products:products.filter(xId=>{return xId.slug == currentProduct.slug}))"
            :key="product.productId"
          >

            <div v-if="loadingDetails === product.productId" class="text-center product__loader">
              <div class="spinner-grow text-primary m-5" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <div class="product__image">
              <img :src="product.img" @click="changeCurrentProduct(product)" />
              <div class="out-of-stock" v-if="product.stock !== null && product.stock < 1">نفدت الكمية</div>
            </div>
            <div class="product__content">
              <h2 class="product__title" @click="changeCurrentProduct(product)">{{product.title_ar}}</h2>
              <p class="product__desc">{{product.sub_title}}</p>
              

              <!-- Price (With and Without Discount) -->
              <p class="product__price" v-if="product.price_discount">
                <span class="discount">{{product.price_discount}}</span>  ر.س <span class="price">{{product.price}}</span> 
              </p>
              <p class="product__price" v-if="!product.price_discount">
                <span class="discount">{{product.price}}</span>  ر.س 
              </p>
              
              <button class="btn btn-danger" v-if="loadingDelete === product.productId" disable>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Deleting...
              </button>

              <button
                class="btn btn-danger"
                @click="handleDeleteProduct(product.productId)"
                v-else
              ><i class="far fa-trash-alt"></i></button>
            </div>
          </div>
        </div>
        <div v-if="currentProduct">
          <button
            @click.prevent="currentProduct = null"
            :disabled="loading"
            class="btn btn-info"
          >Close Current Product</button>
        </div>
        <div v-else-if="loadMoreAvailable">
          <button
            @click.prevent="loadMoreProducts()"
            :disabled="loadingMore"
            class="btn btn-primary"
          >Click to load more</button>
        </div>
        <div v-else>
          <p>No more products</p>
        </div>
      </div>
    </div>
    <div v-if="currentProduct">
      <product-details
        :product="currentProduct"
        :categories="categories"
        :parentCategory="defaultCategory"
        @updateCurrentProduct="updateCurrentProduct($event)"
      ></product-details>
    </div>
  </div>
</template>

<script>
// import {globalStore} from '../../main.js';
import axios from "axios";
// import Product from "./Product.vue";
import { getCookie } from "../../cookie.js";
// import CategoriesNav from './CategoriesNav.vue'
/* eslint-disable no-console */
import { herokuUrl } from "../../apiConfig";
import productDetails from "./ProductDetails";
import logOut from "../../scripts/utils";

export default {
  data() {
    return {
      loadMoreAvailable: true,
      loading: false,
      categories: [],
      products: [],
      defaultCategory: {},
      pageSize: 15,
      pageIndex: 1,
      loadingMore: false,
      currentProduct: null,
      loadingDetails: null,
      loadingDelete: null,
      error: null
    };
  },
  components: {
    productDetails
    // CategoriesNav
  },
  computed: {
    catgoriesTitle() {
      return this.categories.map(cat => cat.filterTitle);
    }
  },
  mounted() {
    // exporting changeCurrentProduct function to use it in another components
    this.$root.$on('component1', (product) => {
        this.changeCurrentProduct(product);
    });
    if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('../../firebase-messaging-sw.js')
        .then(async (reg) => {
          console.log(`Service Worker Registration (Scope: ${reg.scope})`);
          const messaging = this.$messaging;
          // await messaging.useServiceWorker(reg);
          await messaging.requestPermission();
          messaging.getToken({ vapidKey: "BIK65T6Otvpg_inmm13fisbwAY7fgEykhsHnlsY_FLQ8Ft-gw6X8fKSPWuRRMMAuZdhJ9GKImGnhqFt1v8YYAAA" })
          .then((currentToken) => {
            if (currentToken) {
              console.log('client token', currentToken)
              this._saveToken(currentToken);
            } else {
              console.log('No registration token available. Request permission to generate one.');
            }
          }).catch((err) => {
            console.log('An error occurred while retrieving token. ', err);
          })
          messaging.onMessage((payload) => {
            console.log('Message received. ', payload);
            // ...
          });
        })
        .catch(error => {
          const msg = `Service Worker Error (${error})`;
          console.error(msg);
        });
    } else {
      // happens when the app isn't served over HTTPS or if the browser doesn't support service workers
      console.warn('Service Worker not available');
    }
  },
  // setup(){}
  methods: {
    async _saveToken(token){
      await axios.post(`${herokuUrl}/dashboard/saveToken`, {token}).then(resault => {
        console.log(resault)
      }).catch(err => {console.log(err)})
    },
    async getInitialProducts() {
      const categories = await axios.post(`${herokuUrl}/dashboard/categories`, {
        language: 2
      });

      // const products = await axios.post(`${herokuUrl}/dashboard/product-list/${categories.data.categories[0].slug}`,{language: 1, pageSize: this.pageSize, pageIndex: this.pageIndex},{ headers: { Authorization: getCookie('user')} })
      const products = await axios.post(
        // `http://localhost:5001/api/dashboard/product-list/${categories.data.categories[0].slug}`,
        `${herokuUrl}/dashboard/product-list/${categories.data.categories[0].slug}`,
        { language: 1, pageSize: this.pageSize, pageIndex: this.pageIndex },
        { headers: { Authorization: getCookie("user") } }
      );

      this.loading = false;
      this.categories = categories.data.categories;
      this.products = products.data.products;
      this.defaultCategory = this.categories[0];
      if(this.$route.query.selectedOrderId){
        console.log(this.$route.query.selectedOrderId)
        this.changeCurrentProduct(this.products.find(i=>{return i.productId == this.$route.query.selectedOrderId}))
      }
    },
    async getCatogryProducts(category) {
      this.loadMoreAvailable = true;
      this.loading = true;
      this.pageIndex = 1;
      this.currentProduct = null;
      const response = await axios.post(
        `${herokuUrl}/dashboard/product-list/${category.slug}`,
        { language: 1, pageSize: this.pageSize, pageIndex: this.pageIndex },
        { headers: { Authorization: getCookie("user") } }
      );

      this.defaultCategory = category;
      this.loading = false;
      this.products = response.data.products;
    },
    updateCurrentProduct(category) {
      this.currentProduct.category = category;
    },
    async loadMoreProducts() {
      this.loadingMore = true;
      // const response = await axios.post(`https://ithoobapi.web-keyz.comproduct-list/${this.defaultCategory.slug}`, {language: 1, pageSize: this.pageSize, pageIndex: this.pageIndex + 1});
      const response = await axios.post(
        `${herokuUrl}/product-list/${this.defaultCategory.slug}`,
        { language: 1, pageSize: this.pageSize, pageIndex: this.pageIndex + 1 }
      );

      this.pageIndex = this.pageIndex + 1;
      this.loadingMore = false;
      var newProducts = [...this.products, ...response.data.products];
      this.products = newProducts;
      if (response.data.products.length == 0) this.loadMoreAvailable = false;
    },
    changeCurrentProduct(product) {
      this.loading = true;
      this.currentProduct = null;
      this.loadingDetails = product.productId;
      axios
        .post(
          // `${herokuUrl}/dashboard/product-details/${product.slug}`,
          `${herokuUrl}/dashboard/product-details/${product.slug}`,
          { language: 1 },
          { headers: { Authorization: getCookie("user") } }
        )
        .then(response => {
          this.loading = false;
          this.loadingDetails = null;

          this.currentProduct = response.data.productDetails;
        })
        .catch(err => {
          if(err.response.status == 401) {
            logOut();
          } else {
            this.loadingDetails = null;
            this.loading = false;
            this.error = err.data;
          }
        });
    },
    handleDeleteProduct(id) {
      if (confirm("Are you sure you want to delete this product?")) {
        this.currentProduct = null;
        this.loadingDelete = id;
        axios
          .post(
            `${herokuUrl}/dashboard/delete-product`,
            // `http://localhost:5001/api/dashboard/product-details/${product.slug}`,
            { productId: id },
            { headers: { Authorization: getCookie("user") } }
          )
          .then(response => {
            this.loadingDelete = null;
            if (response.data.status) {
              this.products.splice(
                this.products.findIndex(i => i.productId === id),
                1
              );
            } else {
              this.error = response.data.message;
            }
          })
          .catch(err => {
            if(err.response.status == 401) {
              logOut();
            } else {
              this.loadingDelete = null;
              this.error = "error in deleting";
            }
          });
      }
    }
  },
  created() {
    this.loading = true;
    this.getInitialProducts();
  }
};
</script>

<style lang="scss" scoped>
.btn-group > .btn:not(:first-child), .btn-group > .btn-group:not(:first-child) {
  margin-left: 0;
}
.product-types-tabs {
  margin: 1% 0 0.5%;
  
  button {
    color: #fff;
    background: #000;
  }

  button.active {
    color: #fff;
    background: #b78b1e;
  }
}
.products {
  display: flex;
  flex-wrap: wrap;  
  margin-bottom: 20px;
}
.product {
  position: relative;
  width: calc(94%/3);
  position: relative;
  margin: 1%;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;

  @media (min-width: 667px) {
    width: calc(90%/5);
  }

  &__loader {
    border-radius: 10px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    opacity: 0.5;
    background: #fff;
    z-index: 2;
  }
  &__title {
    font-size: 1.2rem;
    font-weight: bold;
    color: #000;
    cursor: pointer;
  }
  &__desc {
    font-size: 0.9rem;
  }
  &__price {
    direction: rtl;
    margin-bottom: 0;
    color: #b78b1e;
    
    .price {
      text-decoration: line-through;
      color: gray;
      margin-left: 10px;
    }

    .discount {
      
    }
  }
  &__image {
    position: relative;
    width: 100%;
    height: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: fill;
      cursor: pointer;
    }

    .out-of-stock {
      position: absolute;
      width: 100%;
      height: 40px;
      font-size: 18px;
      line-height: 40px;
      bottom: 15px;
      text-align: center;
      background: rgba(255, 255, 255, 0.8);
      color: #E72113;
    }
  }
  &__content {
    width: 100%;
    padding: 1rem;
    text-align: right;
  }
  .btn {
    position: absolute;
    left: 1rem;
    top: 1rem;
    padding: 0.25rem 0.5rem;
    opacity: 0;
    transition: all 200ms ease;
  }

  &:hover .btn {
    opacity: 1;
    box-shadow: 0 1px 5px 0px #ae2727
  }
}
.selected-product {
  border: 2px solid black;
}
</style>
